import { Component } from '@theme/component';

/**
 * Ingredient hover/focus glossary.
 *
 * Open/close, one-at-a-time, outside-click, and Escape-to-close all come free
 * from the native Popover API (`popover="auto"`). This only adds keyboard-focus
 * opening and keeps `aria-expanded` in sync with the popover's real state.
 *
 * @extends Component
 */
class CubeIngredientsComponent extends Component {
  /** @param {FocusEvent} event */
  handleFocus(event) {
    const trigger = /** @type {HTMLElement} */ (event.target);
    const popover = trigger.closest('.cube-ingredient')?.querySelector('[popover]');

    if (popover instanceof HTMLElement && !popover.matches(':popover-open')) {
      popover.showPopover();
    }
  }

  /** @param {FocusEvent} event */
  handleBlur(event) {
    const trigger = /** @type {HTMLElement} */ (event.target);
    const popover = trigger.closest('.cube-ingredient')?.querySelector('[popover]');

    if (popover instanceof HTMLElement && popover.matches(':popover-open')) {
      popover.hidePopover();
    }
  }

  /** @param {ToggleEvent} event */
  handleToggle(event) {
    const popover = /** @type {HTMLElement} */ (event.target);
    const trigger = popover.closest('.cube-ingredient')?.querySelector('.cube-ingredient__name');

    if (trigger instanceof HTMLElement) {
      trigger.setAttribute('aria-expanded', event.newState === 'open' ? 'true' : 'false');
    }
  }
}

if (!customElements.get('cube-ingredients')) {
  customElements.define('cube-ingredients', CubeIngredientsComponent);
}
